// v2
let hostname = window.location.hostname;
let api_base_url = false;
let token = localStorage.getItem("selforder-token") || null;

console.log("hostname", hostname);

function setBaseUrl() {
  const local_api_base_url = process.env.REACT_APP_API_BASE_URL;

  if (local_api_base_url) {
    api_base_url = local_api_base_url;
  } else if (hostname === "localhost" || hostname.includes(".localhost")) {
    api_base_url = "http://api.sdm.localhost";
  } else if (hostname.includes(".dev.")) {
    api_base_url = "https://api.dev.yellgo.cloud";
  } else if (hostname.includes(".demo.")) {
    api_base_url = "https://api.demo.yellgo.cloud";
  } else {
    api_base_url = "https://api.yellgo.cloud";
  }

  console.log("api_base_url", api_base_url);
}

function ensureBaseUrl() {
  if (!api_base_url) setBaseUrl();
}

function rememberToken(json) {
  if (json?.token) {
    token = json.token;
    localStorage.setItem("selforder-token", json.token);
  }
  return json;
}

function setToken(t) {
  token = t;
  if (t) localStorage.setItem("selforder-token", t);
  else localStorage.removeItem("selforder-token");
}

function getToken() {
  return token;
}

function setHostname(h) {
  hostname = h;
  console.log("hostname", hostname);
}

function getHostname() {
  return hostname;
}

function headers(protectedRequest = false) {
  const requestHeaders = {
    "Content-Type": "application/json",
    Apiver: 2,
    Hostname: hostname,
  };

  if (protectedRequest && token) requestHeaders.Authorization = "Bearer " + token;

  return requestHeaders;
}

async function request(method, endpoint, body = undefined, protectedRequest = false) {
  ensureBaseUrl();

  const options = {
    method,
    headers: headers(protectedRequest),
  };

  if (body !== undefined) options.body = JSON.stringify(body);

  const response = await fetch(api_base_url + endpoint, options);
  const json = await response.json();

  return rememberToken(json);
}

async function refreshToken(t = token) {
  if (!t) return { success: 0, error: "token is required" };
  setToken(t);
  return request("GET", "/customers/refresh_token/", undefined, true);
}

async function get(endpoint) {
  return request("GET", endpoint);
}

async function getProtected(endpoint) {
  return request("GET", endpoint, undefined, true);
}

async function post(endpoint, requestBody) {
  return request("POST", endpoint, requestBody);
}

async function postProtected(endpoint, requestBody) {
  return request("POST", endpoint, requestBody, true);
}

// Chiamate con un token esplicito (operatore/cameriere della modalità tablet):
// non toccano mai il token cliente salvato in "selforder-token".
async function requestWithToken(method, endpoint, body, staffToken) {
  ensureBaseUrl();

  const requestHeaders = headers(false);
  if (staffToken) requestHeaders.Authorization = "Bearer " + staffToken;

  const options = { method, headers: requestHeaders };
  if (body !== undefined) options.body = JSON.stringify(body);

  const response = await fetch(api_base_url + endpoint, options);
  return response.json();
}

async function postWithToken(endpoint, requestBody, staffToken) {
  return requestWithToken("POST", endpoint, requestBody, staffToken);
}

async function getWithToken(endpoint, staffToken) {
  return requestWithToken("GET", endpoint, undefined, staffToken);
}

async function postWithHostname(endpoint, requestBody, customHostname) {
  ensureBaseUrl();

  const response = await fetch(api_base_url + endpoint, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Apiver: 2,
      Hostname: customHostname,
    },
    body: JSON.stringify(requestBody),
  });

  return rememberToken(await response.json());
}

// Backward-compatible alias for callers that still invoke the old bootstrap.
async function oauth() {
  setBaseUrl();
  return { success: 1 };
}

export default {
  setBaseUrl,
  oauth,
  refreshToken,
  post,
  get,
  getProtected,
  postProtected,
  postWithToken,
  getWithToken,
  postWithHostname,
  setToken,
  getToken,
  setHostname,
  getHostname,
};
